<template>
  <div class="animated fadeIn">
    <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />

    <b-card v-else>
      <template v-slot:header>
        <h5 class="mb-0">Detail Disbursement Pending</h5>
      </template>

      <DetailGadaiKomp
        :detailGadai="detailGadai"
        :hideHistoryPembayaran="true"
        :hideListApprovalDisburse="true"
      />

      <DisbursementPendingStatusSection
        :detailGadai="detailGadai"
        :disbursementPending="disbursementPending"
        :transaction="transaction"
        :isRefreshingStatus="isRefreshingStatus"
        @refresh-status="refreshDisbursementStatus"
      />

      <DisbursementPendingDocumentSection :disbursementPending="disbursementPending" />

      <DisbursementPendingStatusAlert
        :disbursementPending="disbursementPending"
        :transaction="transaction"
      />

      <DisbursementPendingActionSection
        :disbursementPending="disbursementPending"
        :transaction="transaction"
        :refreshDetail="getDisbursementPendingDetail"
      />
    </b-card>
  </div>
</template>

<script>
import CONSTANTS from '@/constants'
import DetailGadaiKomp from '@/components/gadai/DetailGadaiKomp'
import DisbursementPendingActionSection from '@/components/disbursement/DisbursementPendingActionSection'
import DisbursementPendingDocumentSection from '@/components/disbursement/DisbursementPendingDocumentSection'
import DisbursementPendingStatusAlert from '@/components/disbursement/DisbursementPendingStatusAlert'
import DisbursementPendingStatusSection from '@/components/disbursement/DisbursementPendingStatusSection'

export default {
  components: {
    DetailGadaiKomp,
    DisbursementPendingActionSection,
    DisbursementPendingDocumentSection,
    DisbursementPendingStatusAlert,
    DisbursementPendingStatusSection,
  },
  data() {
    return {
      initStatus: 0,
      detailGadai: {},
      disbursementPending: {},
      transaction: {
        status: CONSTANTS.GADAI.STATUS_DISBURSEMENT_PENDING.PENDING,
        statusDisburse: CONSTANTS.GADAI.STATUS_DISBURSEMENT_GADAI.DANA_DITANGGUHKAN,
        nominalPenerimaan: null,
        sisaKekurangan: null,
      },
      isRefreshingStatus: false,
    }
  },
  methods: {
    init() {
      this.initStatus = 0

      this.getDisbursementPendingDetail().then(item => {
        return this.$axios.get(`gadai/detail/id/${item.gadaiId}`)
      }).then(response => {
        this.detailGadai = response.data
        this.initStatus = 1
      }).catch(error => {
        this.$helper.parseError(this, error)
        this.initStatus = -1
      })
    },
    getDisbursementPendingDetail() {
      const params = {
        page: 0,
        size: 10,
        noFaktur: this.$route.params.id,
      }

      return this.$axios.get('gadai-disburse/pending', { params }).then(response => {
        const item = response.data && response.data.content ? response.data.content[0] : null

        if (!item) {
          throw new Error('Data disbursement pending tidak ditemukan.')
        }

        this.disbursementPending = item
        this.setTransactionFromPending(item)

        return item
      })
    },
    async refreshDisbursementStatus() {
      this.isRefreshingStatus = true

      try {
        await this.getDisbursementPendingDetail()
        this.$helper.toastSucc(this, 'Status disbursement berhasil diperbarui.')
      } catch (error) {
        this.$helper.parseError(this, error)
      } finally {
        this.isRefreshingStatus = false
      }
    },
    setTransactionFromPending(item) {
      this.transaction.status = item.gadaiDisbursePendingStatus
      this.transaction.statusDisburse = item.gadaiDisburseStatus
      this.transaction.nominalPenerimaan = item.transferAmount || 0
      this.transaction.sisaKekurangan = item.remainingAmount || 0
    },
  },
  created() {
    this.init()
  },
}
</script>
